module.exports = __webpack_public_path__ + "img/fondculturesoja.b22a75bc.png";